import { TableBody, TableHeader, TableRow } from '@lokalise/louis';
import { useEffect, useState } from 'react';

import { useGetLanguagesQuery, useGetProjectsQuery, useGetStyleGuidesQuery } from '@app/api/styleGuide';
import EmptySearchState from '@app/components/EmptySearchState';

import { useStyleGuideContext } from './StyleGuideContext';
import { EmptyPage, LoadingSkeleton, StyleGuideListToolbar, StyleGuideRow } from './components';
import {
    Container,
    TableContainer,
    TableHeadActionCellContainer,
    TableHeadCellContainer,
    TableHeadStatusCellContainer,
} from './styles';

export { default as splitFileName } from './utils/splitFileName';

const StyleGuidePage = () => {
    const [searchValue, setSearchValue] = useState('');

    const { setLanguages, setProjects, teamId } = useStyleGuideContext();

    const {
        data: styleGuides,
        isLoading: isStyleGuidesLoading,
        isError: isStyleGuidesError,
    } = useGetStyleGuidesQuery({ teamId, ...(searchValue && { name: searchValue }) });
    const { data: languagesData, isLoading: isLanguagesLoading } = useGetLanguagesQuery({ teamId });
    const { data: projectsData, isLoading: isProjectsLoading } = useGetProjectsQuery({ teamId });

    const isLoading = isStyleGuidesLoading || isLanguagesLoading || isProjectsLoading;

    useEffect(() => {
        if (languagesData && projectsData) {
            setProjects(projectsData);
            setLanguages(languagesData);
        }
    }, [languagesData, setLanguages, projectsData, setProjects]);

    if (!searchValue && (styleGuides?.length === 0 || isStyleGuidesError) && !isLoading) {
        return <EmptyPage />;
    }

    const nothingFound = searchValue && styleGuides && styleGuides.length === 0;

    return (
        <Container>
            <StyleGuideListToolbar onSearch={setSearchValue} />
            {!nothingFound && (
                <TableContainer>
                    <TableHeader>
                        <TableRow>
                            <TableHeadCellContainer>Styleguide/File</TableHeadCellContainer>
                            <TableHeadCellContainer>Language</TableHeadCellContainer>
                            <TableHeadCellContainer>Projects</TableHeadCellContainer>
                            <TableHeadCellContainer>Created by</TableHeadCellContainer>
                            <TableHeadStatusCellContainer>AI status</TableHeadStatusCellContainer>
                            <TableHeadActionCellContainer colSpan={1} align="right" />
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {isLoading ? (
                            <LoadingSkeleton rowsCount={styleGuides?.length} />
                        ) : (
                            styleGuides?.map((styleGuide) => (
                                <StyleGuideRow key={styleGuide.id} styleGuide={styleGuide} />
                            ))
                        )}
                    </TableBody>
                </TableContainer>
            )}

            {nothingFound && <EmptySearchState description="Try a different search term or upload new style guide." />}
        </Container>
    );
};

export default StyleGuidePage;
